import { Field, useFormikContext } from 'formik';
import { FormErrorUI, FormLabelUI, InputUI } from '../Interface';

const JokerFormFields = ({ viewField }) => {
  const { values, errors } = useFormikContext();

  return (
    <div className="mx-4">
      <Field
        type="text"
        name="name"
        as={InputUI}
        fullWidth
        label={<FormLabelUI text="Megnevezés" />}
        variant="standard"
        helperText={<FormErrorUI message={errors.name} />}
        disabled={viewField}
        InputLabelProps={{ shrink: values.name !== '' }}
      />
    </div>
  );
};

export default JokerFormFields;
